"use client";

import { useEffect } from "react";

/**
 * Hook that triggers a callback when the Escape key is pressed.
 *
 * @param callback - Function to call when Escape is pressed
 * @param enabled - Whether the escape key handler is active (default: true)
 *
 * @example
 * ```tsx
 * useEscapeKey(() => setIsOpen(false), isOpen);
 * ```
 */
export function useEscapeKey(callback: () => void, enabled = true): void {
  useEffect(() => {
    if (!enabled) return;

    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        callback();
      }
    };

    document.addEventListener("keydown", handleEscape);
    return () => document.removeEventListener("keydown", handleEscape);
  }, [callback, enabled]);
}
